import { __extends, __rest } from "tslib";
import * as React from 'react';
import AnimatableDiv from 'shared/symbols/AnimatableDiv';
import { debounce } from 'shared/utils';
import { joinClass, mouseEventProps } from '../symbolUtils';
import { calcClasses, calcScale, calcTextStyles } from './calcUtils';
export var textAttributeStyleMap = {
    horizontalAlignment: {
        left: { textAlign: 'left' },
        center: { textAlign: 'center' },
        right: { textAlign: 'right' },
        justify: { textAlign: 'justify' },
    },
    verticalAlignment: {
        top: { alignItems: 'flex-start' },
        center: { alignItems: 'center' },
        bottom: { alignItems: 'flex-end' },
    },
};
var initialState = { scale: 1 };
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.checkForOverflow = debounce(function () {
            if (!_this.containerRef) {
                return;
            }
            _this.setState({
                scale: calcScale(_this.state.scale, _this.containerRef, _this.props),
            });
        }, 25);
        /**
         * Share the ref between `withPositionable` (in Editor) and the local instance.
         */
        _this.createContainerRef = function (positionableRef) { return function (element) {
            if (positionableRef && 'current' in positionableRef) {
                // @ts-ignore
                positionableRef.current = element;
            }
            _this.containerRef = element;
        }; };
        return _this;
    }
    Text.prototype.componentDidMount = function () {
        this.checkForOverflow();
        window.addEventListener('resize', this.checkForOverflow);
        document.addEventListener('assetsLoaded', this.checkForOverflow);
    };
    Text.prototype.componentDidUpdate = function (prevProps) {
        var _ = prevProps.innerRef, prevPropsWithoutRef = __rest(prevProps, ["innerRef"]);
        var _a = this.props, __ = _a.innerRef, propsWithoutRef = __rest(_a, ["innerRef"]);
        if (JSON.stringify(prevPropsWithoutRef) ===
            JSON.stringify(propsWithoutRef)) {
            return;
        }
        this.checkForOverflow();
    };
    Text.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.checkForOverflow);
        document.removeEventListener('assetsLoaded', this.checkForOverflow);
    };
    Text.prototype.render = function () {
        var _a = this.props, conditionalState = _a.conditionalState, disabled = _a.disabled, hoverAnimation = _a.hoverAnimation, symbol = _a.symbol, timelineRefId = _a.timelineRefId, innerRef = _a.innerRef, isAnimationMode = _a.isAnimationMode;
        var scale = this.state.scale;
        var _b = mouseEventProps(symbol, disabled, hoverAnimation), clickClass = _b.clickClass, onClick = _b.onClick;
        var attributes = conditionalState.attributes, position = conditionalState.position;
        var content = attributes ? attributes.content : '';
        var textClass = calcClasses(this.props, scale);
        var className = joinClass(textClass, clickClass);
        return (React.createElement(AnimatableDiv, { className: className, hoverAnimation: hoverAnimation, id: timelineRefId, innerRef: this.createContainerRef(innerRef), isAnimationMode: isAnimationMode, onClick: onClick, style: calcTextStyles(this.props, scale), position: position },
            React.createElement("div", { style: {
                    boxSizing: 'border-box',
                    cursor: 'inherit',
                    width: '100%',
                }, dangerouslySetInnerHTML: { __html: content } })));
    };
    return Text;
}(React.Component));
export { Text };
export default Text;
